<template>

    <div class="app">

        <header class="header">
            <div class="container">

                <user-menu/>

            </div>
        </header>

        <div class="content content-outer">
            <div class="container">

                <router-view/>

            </div>
        </div>

        <main-footer/>

        <help-pane/>

        <user-logout-timer/>
    </div>

</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'app',
    async beforeCreate () {
        // this.setTheme()
        this.$store.commit('initStore')
        this.$user.loadEnvironment()
        // console.log('[READ]', JSON.parse(localStorage.getItem('vuex')))

        document.title = 'The Yard'
        const env = this.$store.state.environment
        if (env !== 'production') {
            document.title += ` [${env}]`
        }

        // this.$user.checkAuth() //TODO prevent this call from kicking non-authed users on public pages
    }
})

</script>


<style lang="scss">

/* base styles for app */
@import '../sass/base';
/* import all themes here - only one will be active at a time, but we select it at runtime */
@import '../sass/themes/default';
//@import '../sass/themes/other';

@media print {
    .app > header {
        display: none;
    }
}

.row.divider {
    border-top: solid 1px #ddd !important;
    margin: 15px 0 0 0;
    padding-top: 10px;
}

</style>
